import { useState, useEffect } from 'react';
import { ExSideDrawer } from '@boomi/exosphere';
import ConnectorList from '../connectors/ConnectorList';
import ConnectionCreate from './ConnectionCreate';
import ConnectionEdit from './ConnectionEdit';
import styles from './ConnectionDrawer.module.css';

export type DrawerMode =
    | { type: 'create'; connectorId?: string }
    | { type: 'edit'; connectorId: string; connectionId: string };

interface ConnectionDrawerProps {
    mode: DrawerMode | null;
    onClose: () => void;
}

const ConnectionDrawer = ({ mode, onClose }: ConnectionDrawerProps) => {
    const [selectedConnectorId, setSelectedConnectorId] = useState<string | null>(null);

    useEffect(() => {
        if (!mode) setSelectedConnectorId(null);
        else if (mode.type === 'create' && mode.connectorId)
            setSelectedConnectorId(mode.connectorId);
    }, [mode]);

    const isOnCreateForm = mode?.type === 'create' && selectedConnectorId !== null;

    const title = mode?.type === 'edit' ? 'Edit Config' : 'Create Config';

    const handleClose = () => {
        setSelectedConnectorId(null);
        onClose();
    };

    useEffect(() => {
        if (mode !== null) {
            document.documentElement.style.overflow = 'hidden';
            document.documentElement.scrollTop = 0;
        }

        return () => {
            document.documentElement.style.overflow = 'auto';
        };
    }, [mode]);

    return (
        <ExSideDrawer
            open={mode !== null}
            top={56}
            width="75"
            noMarginSlot
            panelTitle={title}
            navigation={isOnCreateForm}
            onCancel={() => (isOnCreateForm ? setSelectedConnectorId(null) : handleClose())}
            onClose={handleClose}
            className={styles.connectionDrawer}
        >
            {mode?.type === 'create' && !selectedConnectorId && (
                <ConnectorList onSelect={setSelectedConnectorId} />
            )}
            {mode?.type === 'create' && selectedConnectorId && (
                <ConnectionCreate connectorId={selectedConnectorId} onClose={handleClose} />
            )}
            {mode?.type === 'edit' && (
                <ConnectionEdit
                    connectorId={mode.connectorId}
                    connectionId={mode.connectionId}
                    onClose={handleClose}
                />
            )}
        </ExSideDrawer>
    );
};

export default ConnectionDrawer;
